import React from "react";
import moment from "moment";
import { AuthService } from "../services/auth.service";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import ReceiptIcon from "@material-ui/icons/Receipt";
import BallotIcon from "@material-ui/icons/Ballot";
import PaymentIcon from "@material-ui/icons/Payment";
import SdCardIcon from "@material-ui/icons/SdCard";

export const buildErrResponse = (errResponse) => {
  console.log("errResponse", errResponse);
  console.log("errResponse", errResponse.response);
  const { data, status } = errResponse.response;
  if ([401, 403].indexOf(status) !== -1) {
    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
    console.log("LOGOUT HEREEE");
    AuthService.logout();
    return {
      status,
      msgs: "Permiso denegado a este servicio",
    };
  }

  if (data && Object.values(data).length) {
    return {
      status,
      msgs: data.message,
    };
  } else {
    return {
      status: 500,
      msgs: "Error al establecer conexión. Intentar mas tarde",
    };
  }
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const handleRequestSort = (event, property, state, orderAsc) => {
  const isAsc = state === property && orderAsc === "asc";
  return { property, ordering: isAsc ? "desc" : "asc" };
};

export const handleSelectAllClick = (event, state) => {
  if (event.target.checked) {
    const newSelected = state.map((n) => n.id);
    return newSelected;
  }
  return [];
};

export const changeRowsPerPage = (event) => {
  return { rowsPerPage: parseInt(event.target.value, 10), page: 0 };
};

export const customDate = (originalDate) => {
  if (typeof originalDate === "string") {
    const [date, time] = originalDate.split(" ");
    const formatDate = date.split("-").reverse().join("-");
    const [hours, minutes] = time.split(":");
    return `${formatDate} ${hours}:${minutes}`;
  } else return "--";
};

export const reverseChain = (s) => [...s].reverse().join("");

export const filterMovilesByBarCode = (products) => {
  let ids = new Set();
  return products.filter((item) => {
    if (!ids.has(item.movile.barCode)) {
      ids.add(item.movile.barCode);
      return true;
    }
    return false;
  });
};

export const filterChipsByLote = (products) => {
  let ids = new Set();
  return products.filter((item) => {
    if (!ids.has(item.chip.lote)) {
      ids.add(item.chip.lote);
      return true;
    }
    return false;
  });
};

export const filterProductsByModel = (products) => {
  let ids = new Set();
  return products.filter((item) => {
    if (!ids.has(item.model)) {
      ids.add(item.model);
      return true;
    }
    return false;
  });
};

export const orderProductsModel = (a, b) =>
  a.model > b.model ? 1 : b.model > a.model ? -1 : 0;

export const filterProductAccesoriesByBarCode = (products) => {
  let ids = new Set();
  return products.filter((item) => {
    if (!ids.has(item.accesory.barCode)) {
      ids.add(item.accesory.barCode);
      return true;
    }
    return false;
  });
};

export const filterAccesoriesByBarCode = (accesories) => {
  let ids = new Set();
  return accesories.filter((item) => {
    if (!ids.has(item.barCode)) {
      ids.add(item.barCode);
      return true;
    }
    return false;
  });
};

export const filterCashCardByBarCode = (products) => {
  let ids = new Set();
  return products.filter((item) => {
    if (!ids.has(item.cash_card.card_catalogue.barCode)) {
      ids.add(item.cash_card.card_catalogue.barCode);
      return true;
    }
    return false;
  });
};

export const removeEmptySpace = (value) => {
  if (typeof value === "string") return value.trim();
  return value;
};

export const getAvailableQuantity = (index, productsArray) => {
  let result = "";
  productsArray.forEach(({ i, availables }) => {
    console.log("availables", availables);
    console.log("index", index);
    if (index === i) result = availables;
  });
  return result;
};

export const filterMovilesBrand = (data) => {
  const brandUpperCase = data.map((product) =>
    product.movile.brand.toUpperCase()
  );
  return brandUpperCase.filter(
    (movile, i) => brandUpperCase.indexOf(movile) === i
  );
};

export const filterAccesoriesBrand = (data) => {
  return data.sort((a, b) => {
    if (a.brand < b.brand) {
      return -1;
    }
    if (a.brand > b.brand) {
      return 1;
    }
    return 0;
  });
};

/**
 * The values are setter in roleEnum
 * any modification there is gonna be affected here
 * @param {*} roleId
 */
export const getRoleName = (roleId) => {
  let role = "";
  if (roleId) {
    switch (roleId) {
      case 1:
        role = "Administrador";
        break;
      case 2:
        role = "Jefe de Almácen Moviles";
        break;
      case 3:
        role = "Jefe de Almácen Accesorios";
        break;
      case 4:
        role = "Vendedor";
        break;
      case 5:
        role = "Auxiliar de garantías";
        break;
      default:
        role = "N/A";
        break;
    }
  }
  return role;
};

export const validateEmptyValuesInForm = (objectValue) => {
  const validateObject = {};
  Object.entries(objectValue).forEach(([key, value]) => {
    if (value !== "") validateObject[key] = removeEmptySpace(value);
  });
  return validateObject;
};

export const getProductType = (option) => {
  switch (option) {
    case 1:
      return "Equipo móvil";
    case 2:
      return "Accesorio";
    case 3:
      return "Chips";
    case 4:
      return "Tarjeta saldo";
    case 5:
      return "Trasp. saldo";
    case 6:
      return "Plan tarifario";
    default:
      break;
  }
};

export const getProductPrice = (item) => {
  const { product } = item;
  const price =
    product.movile?.price ||
    product.accesory?.price ||
    product.chip?.price ||
    product.cash_card?.card_catalogue?.amount ||
    product.balance_transfer?.amount ||
    product.phone_plan?.amount ||
    0;
  return `$ ${price}`;
};

export const getProductDiscount = (item) => {
  const { product } = item;
  const discount =
    product.movile?.discount ||
    product.accesory?.discount ||
    product.cash_card?.discount ||
    product.balance_transfer?.discount ||
    0;
  return `${discount}`;
};

export const getProductDiscountForReceipt = (item) => {
  const { product } = item;
  const discount =
    product.movile?.discount ||
    product.accesory?.discount ||
    product.cash_card?.discount ||
    product.balance_transfer?.discount ||
    null;
  return `${discount}`;
};

export const getProductInfoSells = (item) => {
  const { product } = item;
  let information = "";
  if (product.movile) information = product.movile?.imeiCode;
  else if (product.accesory) {
    information = product.accesory.subcategory_type?.name;
  } else if (product.chip) information = product.chip.iccid;
  else if (product.balance_transfer)
    information = product.balance_transfer.paymentPending
      ? "Pendiente de pago"
      : "Pago completo";
  // else if (product.cash_card) information = product.cash_card.name;
  else information = "N/A";
  return information;
};

export const getProductBarCode = (item) => {
  const { product } = item;
  let barCode = "";
  if (product.movile) barCode = product.movile?.barCode;
  else if (product.accesory) barCode = product.accesory.barCode;
  else if (product.chip) barCode = product.chip.chip_catalogue.barCode;
  else if (product.cash_card)
    barCode = product.cash_card.card_catalogue?.barcode;
  else barCode = "N/A";
  return barCode;
};

export const getProductPriceInSells = (item) => {
  let amount = 0;
  const { product } = item;
  if (product.movile) amount = product.movile.price;
  else if (product.accesory) amount = product.accesory.price;
  else if (product.chip) amount = product.chip.price;
  else if (product.balance_transfer) amount = product.balance_transfer?.amount;
  else if (product.cash_card) amount = product.cash_card.card_catalogue?.amount;
  else if (product.phone_plan) amount = product.phone_plan.amount;

  return amount;
};

export const calculateTotalSells = (data) => {
  let total = 0;
  data.forEach((item) => {
    const price = getProductPriceInSells(item);
    const discount = getProductDiscount(item);
    if (!item.product.balance_transfer?.paymentPending)
      total += price - discount;
  });
  return total;
};

export const getProductPriceWithoutIVA = (importe) => {
  const basePrice = importe / 1.16;
  return basePrice;
};

export const fixedNumberValue = (numb) => numb.toFixed(2);

export const getIVAProduct = (impuestoBase) => {
  const IVA = impuestoBase * 0.16;
  return IVA;
};

export const getProductPriceInTicketReport = (item) => {
  const price =
    item.movile?.price ||
    item.accesory?.price ||
    item.chip?.price ||
    item.cash_card?.card_catalogue?.amount ||
    item.balance_transfer?.amount ||
    item.phone_plan?.amount ||
    0;
  return `${price}`;
};

export const getProductDiscountInTicketReport = (item) => {
  const price =
    item.movile?.discount ||
    item.accesory?.discount ||
    item.chip?.discount ||
    item.cash_card?.discount ||
    item.balance_transfer?.discount ||
    0;
  return `${price}`;
};

export const getBrandAndModel = (item, showExtraInfo) => {
  const { product } = item;
  const brand =
    product.movile?.brand ||
    product.accesory?.brand ||
    product.chip?.chip_catalogue?.name ||
    product.cash_card?.card_catalogue?.name ||
    product.balance_transfer?.balance_catalogue?.name ||
    product.phone_plan?.concept.slice(0, 12) + "..." ||
    "";
  const model =
    product.movile?.model ||
    product.accesory?.model ||
    product.cash_card?.card_catalogue?.amount ||
    product.balance_transfer?.amount ||
    "";

  let extraInfo = "";
  if (showExtraInfo) {
    extraInfo = product.movile
      ? `IMEI ${product.movile?.imeiCode}`
      : product.accesory
      ? `Código de barras ${product.accesory?.barCode}`
      : "";
  }

  return `${brand} ${model} ${extraInfo}`;
};

export const getProviderName = (item) => {
  const { product } = item;
  const name =
    product.movile?.provider?.name ||
    product.accesory?.provider?.name ||
    // product.cash_card?.card_catalogue?.provider?.name ||
    "N/A";
  return name;
};
export const getTimeGuarantee = (item) => {
  const { product } = item;
  const time =
    product.movile?.provider?.timeGuarantee ||
    product.accesory?.provider?.timeGuarantee ||
    product.cash_card?.card_catalogue?.provider?.timeGuarantee ||
    "N/A";
  return time;
};

export const getRemainingDaysGuarantee = (item) => {
  const productGuaranteeDays = getTimeGuarantee(item);
  const sellDate = moment(item.updatedAt);
  const currentDay = moment();
  const remainingDays = currentDay.diff(sellDate, "days");
  let result = "";
  if (productGuaranteeDays !== "N/A") {
    result = productGuaranteeDays - remainingDays;
  } else result = "N/A";
  return result;
};

export const createSellRow = (
  typeOfReport,
  site,
  productType,
  branModel,
  imeiSubcategory,
  barCode,
  price,
  discount,
  seller,
  date,
  lote
) =>
  ({
    sellsByUser: [
      productType,
      branModel,
      imeiSubcategory,
      barCode,
      price,
      discount,
      date,
      lote,
    ],
    sellsBySite: [
      productType,
      branModel,
      imeiSubcategory,
      barCode,
      price,
      discount,
      seller,
      date,
      lote,
    ],
    globalSells: [
      site,
      productType,
      branModel,
      imeiSubcategory,
      barCode,
      price,
      discount,
      seller,
      date,
      lote,
    ],
  }[[typeOfReport]]);

export const createTicketSellRow = (
  quantity,
  description,
  unitPrice,
  discount,
  total
) => {
  return [quantity, description, unitPrice, discount, total];
};

export const removeDuplicateSitesInProducts = (productArr, productTypeId) => {
  const key =
    productTypeId === 1
      ? "movile"
      : productTypeId === 2
      ? "accesory"
      : productTypeId === 3
      ? "chip"
      : "cash_card";

  let ids = new Set();
  return productArr.filter((item) => {
    if (!ids.has(item[key].siteId)) {
      ids.add(item[key].siteId);
      return true;
    }
    return false;
  });
};

export const catalogArray = [
  {
    labelName: "Catálogo de saldos",
    name: "balance",
    icon: (
      <PaymentIcon
        style={{
          backgroundColor: "#3246D3",
          marginTop: 8,
          marginLeft: 10,
          height: 45,
          fontSize: 50,
          borderRadius: 4,
        }}
        color="secondary"
      />
    ),
  },
  {
    labelName: "Catálogo de recargas",
    name: "rechargeCard",
    icon: (
      <BallotIcon
        style={{
          backgroundColor: "#FA78CD",
          marginTop: 8,
          marginLeft: 10,
          height: 45,
          fontSize: 50,
          borderRadius: 4,
        }}
        color="secondary"
      />
    ),
  },
  {
    labelName: "Catálogo de chips",
    name: "chip",
    icon: (
      <SdCardIcon
        style={{
          backgroundColor: "#85e085",
          marginTop: 8,
          marginLeft: 10,
          height: 45,
          fontSize: 50,
          borderRadius: 4,
        }}
        color="secondary"
      />
    ),
  },
  {
    labelName: "Catálogo tipific. Garantías",
    name: "tipifications",
    icon: (
      <FindInPageIcon
        style={{
          backgroundColor: "#ffb3b3",
          marginTop: 8,
          marginLeft: 10,
          height: 45,
          fontSize: 50,
          borderRadius: 4,
        }}
        color="secondary"
      />
    ),
  },
  {
    labelName: " Catálogo de estatus (garantía)",
    name: "status",
    icon: (
      <ReceiptIcon
        style={{
          backgroundColor: "#d2a679",
          marginTop: 8,
          marginLeft: 10,
          height: 45,
          fontSize: 50,
          borderRadius: 4,
        }}
        color="secondary"
      />
    ),
  },
];

export const isBalanceTransferInCart = (cart) => {
  return Object.values(cart).some((item) => item.productTypeId === 5);
};

export const sliceText = (text, size) => {
  if (text) {
    let customText = "";
    customText =
      text.length < size ? text : text.substring(0, size).concat("...");
    return customText;
  } else return "";
};

export const validateReceiptForm = (billObject) => {
  let receiptResponse = { isError: false, message: "" };
  if (!billObject["usoCfdi"]) {
    receiptResponse = {
      isError: true,
      message: "El campo 'uso CFDI' se encuentra vacio, verificar",
    };
  } else if (!billObject["rfc"]) {
    console.log("rfc vacio");
    receiptResponse = {
      isError: true,
      message: "El campo RFC se encuentra vacio, verificar",
    };
  } else if (billObject["rfc"]?.length < 12) {
    console.log("rfc tmaño");
    receiptResponse = {
      isError: true,
      message: "El RFC tiene un formato incorrecto, verificar",
    };
  } else if (!billObject["name"]) {
    console.log("nombre vacio");
    receiptResponse = {
      isError: true,
      message: "La razón social se encuentra vacia, verificar",
    };
  } else if (billObject["name"]?.length <= 5) {
    console.log("nombre tamaño");
    receiptResponse = {
      isError: true,
      message: "La razón social debe ser mayor a 5 carácteres, verificar",
    };
  } else if (billObject["email"]) {
    const validateEmail = regExEmail.test(billObject["email"]);
    if (!validateEmail)
      receiptResponse = {
        isError: true,
        message: "El email ingresado no es valido, verificar",
      };
  }
  return receiptResponse;
};

const regExEmail =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
